export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: '安全な支払いページ',
      description: '私たちはあなたの金融情報を安全に暗号化しています',
      methodErrorTips: '申し訳ありません。あなたが選択した国は現在サポートされていません。別の国を選択して再度お試しください。',
      recommendation: '推奨',
      cardNumber: 'カード番号',
      cardName: 'カード名義人',
      cvv: 'CVV',
      expiredDate: '有効期限',
      billingInfo: '請求情報',
      country: '国',
      state: '州',
      firstName: '名',
      lastName: '姓',
      document: '書類',
      city: '市',
      address: '住所',
      streetNumber: '番地',
      zipCode: '郵便番号',
      email: 'メール',
      phone: '電話番号',
      pay: '支払う',
      choosePaymentMethod: '支払い方法を選択',
      continue: '続ける',
      later: '後で',
      returnToMerchant: 'キャンセルして商人に戻る',
      resultToMerchant: '商人に戻る',
      orderId: '注文ID',
      orderAmount: '注文金額',
      billingDescriptor: '請求記述子',
      goodsName: '商品名',
      timeLimit: '時間内に支払いを完了してください。そうしないとページがタイムアウトします',
      otherPaymentMethods: 'その他の支払い方法',
      close: '閉じる',
      paymentErrorTitle: '支払い失敗',
      paymentErrorTip: 'お支払いが正常に処理されませんでした。再度お試しください。',
      paymentFailed: '支払い処理に失敗しました',
      continueShopping: 'ショッピングを続ける',
      paymentSuccess: '支払いが正常に完了しました',
      paymentPending: '支払い送信済み、確認中',
      correctDateTip: '有効な有効期限を入力してください',
      correctCardNumberTip: '有効なカード番号を入力してください',
      correctSecurityCodeTip: '有効なセキュリティコードを入力してください',
      mobileMoneyOperator: 'モバイルマネー事業者',
      bank: '銀行',
      correctEmailAddressTip: '正しいメールアドレスを入力してください',
      notSupportPaymentTip: '現在の環境では{type}決済に対応していません',
      addValidPaymentCard: '有効な支払いカードを追加してください',
      timeLimitTip: '試用期間終了の12時間前(<span class="date">{date}</span>)に請求され、その後<span class="date">{month}</span>か月ごとに<span class="amount"> {amount} {currency}</span>で自動更新されます。いつでもキャンセル可能です',
      product: '製品/サービス',
      subscribeType: 'サブスクリプションタイプ',
      renewCycle: '更新サイクル',
      renewAmount: '更新金額',
      subscribePay: 'サブスクリプションして支払う',
      readAgreement: "<span class='protocol-link' style='color: #31a7da;'>《自動更新契約》</span>を読み、同意する",
      depict: '説明',
      copyQrCode: 'QRコードをコピー',
      copySuccess: 'QRコードをコピーしました',
      copyError: 'QRコードをコピーに失敗しました',
      refreshQrCode: 'QRコードを更新'
    },
    subscribe: {
      yourSubscribe: 'あなたのサブスクリプション',
      unsubscribeTip: 'キャンセルする場合は、ページ下部の[サブスクリプションをキャンセル]ボタンをクリックしてください。',
      renewTip: '<span class="date">{date}</span>に<span class="amount"> {amount} {currency}</span>が請求されます。いつでもキャンセル可能です',
      unsubscribe: 'サブスクリプションをキャンセル',
      autoRenew: '自動更新契約',
      unsubscribeTipTwo: '今すぐキャンセルしても、<span class="date">{date}</span>までこのサブスクリプションをご利用いただけます。',
      emailVerifyTip: 'メール認証',
      inputCodeTip: '認証コードを入力してください',
      sendSuccessTip: '認証コードの送信に成功しました',
      sendErrorTip: '認証コードの送信に失敗しました',
      unsubscribeSuccessTip: 'サブスクリプションのキャンセルに成功しました',
      unsubscribeErrorTip: 'サブスクリプションのキャンセルに失敗しました',
      sendCodeTip: '{code}秒後に再送信',
      sendEmailTip: '認証コードを取得',
      daily: '日ごと',
      weekly: '7日ごと',
      monthly: '30日ごと',
      quarterly: '90日ごと',
      semiAnnually: '180日ごと',
      annually: '365日ごと',
      regularRenewal: '定期更新',
      oneTime: 'ワンタイム',
      inputNumberTip: '数字を入力してください',
      eachCalendarMonth: '毎暦月'
    },
    common: {
      confirm: '確認',
      cancel: 'キャンセル',
      uploadImgErrorTip: '画像のみアップロードできます',
      inputMessageTip: '内容を入力してください',
      sendSuccessTip: '送信成功',
      sendErrorTip: '送信失敗',
      inputPlaceholder: '「{field}」を入力してください',
      selectPlaceholder: '「{field}」を選択してください',
      correctFormat: '正しい形式を入力してください（例：{example}）'
    }
  }
}
